module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: ['navbar', 'navbar-' + _vm.type, _vm.placement === 'static' ? 'navbar-static-top' : 'navbar-fixed-' + _vm.placement]
  }, [_c('div', {
    class: _vm.container === 'fluid' ? 'container-fluid' : 'container'
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [(!_vm.$slots.collapse) ? _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "aria-expanded": "false"
    },
    on: {
      "click": _vm.toggleCollapse
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]) : _vm._e(), _vm._v(" "), _vm._t("collapse"), _vm._v(" "), _vm._t("brand")], 2), _vm._v(" "), _c('div', {
    class: ['navbar-collapse', {
      collapse: _vm.collapsed
    }]
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.$slots.left) ? _c('ul', {
    staticClass: "nav navbar-nav navbar-left"
  }, [_vm._t("left")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.right) ? _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_vm._t("right")], 2) : _vm._e()])])])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-141a01ca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-141a01ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Navbar.vue
// module id = 130
// module chunks = 0